import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import type {
  LokiLabelListResponse, LokiLabelValuesResponse,
  LokiStreamsProxyResponse, LokiTailResponse
} from '@partiri-cloud/types';

/**
 * @class ServiceLogsApi
 * @description Logs related to a service
 */
export class ServiceLogsApi {
  endpoint = '/logs'
  constructor(private http: HttpClient) { }

  /**
   * Read logs for a service
   * @param service 
   * @returns 
   */
  public readLogs(service: string, deployTag: string): Observable<LokiStreamsProxyResponse> {
    return this.http.get<LokiStreamsProxyResponse>(`${this.endpoint}/${service}`, { params: { deployTag } });
  }

  /**
   * Tail logs for a service
   * @param service 
   * @returns 
   */
  public readLiveLogs(service: string, deployTag: string): Observable<LokiTailResponse> {
    return this.http.get<LokiTailResponse>(`${this.endpoint}/live/${service}`, { params: { deployTag } });
  }

  /**
   * Read labels related to a service
   * @param service 
   * @returns 
   */
  public readLabels(service: string): Observable<LokiLabelListResponse> {
    return this.http.get<LokiLabelListResponse>(`${this.endpoint}/labels/${service}`);
  }

  /**
   * Read label values for a service
   * @param service 
   * @returns 
   */
  public readLabelValues(service: string, label: string): Observable<LokiLabelValuesResponse> {
    return this.http.get<LokiLabelValuesResponse>(`${this.endpoint}/${service}/${label}`)
  }
}
